import { render, staticRenderFns } from "./EnquiryList.vue?vue&type=template&id=3582daee&"
import script from "./EnquiryList.vue?vue&type=script&lang=js&"
export * from "./EnquiryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports